import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetHepExercisesQuery } from "./hepexercisesApiSlice"
import { memo } from 'react'

const HepExercise = ({ hepId, isMobile, index, dragStart, dragEnter, drop }) => {

    const { hep } = useGetHepExercisesQuery("hepexercisesList", {
        selectFromResult: ({ data }) => ({
            hep: data?.entities[hepId]
        }),
    })

    const navigate = useNavigate()

    if (hep) {
        const handleEdit = () => navigate(`/dash/hep/exercises/${hepId}`)

        return (
            <tr 
            onDragStart={(e) => dragStart(e)}
            onDragEnter={(e) => dragEnter(e)}
            onDragEnd={drop}
            draggable
            id={index}>
                <td>{hep.exercise_id.exercise_name}</td>
                {isMobile === false && <td>{hep.description}</td>}
                <td>
                    <span
                        className="text-secondary"
                        role="button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare}  className="fa-icon"/>
                    </span>
                </td>
            </tr>
        )

    } else return null
}

const memoizedNote = memo(HepExercise)

export default memoizedNote